<template>
<v-list-tile @click="share">
	<v-list-tile-action>
		<v-icon small>fa-share-alt</v-icon>
	</v-list-tile-action>
	<v-list-tile-content>
		<v-list-tile-title small>Share</v-list-tile-title>
		<v-list-tile-sub-title small>Share this entry</v-list-tile-sub-title>
	</v-list-tile-content>
</v-list-tile>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmRowActionShare",

	props: {
		row: Object
	},

	computed: {
		...Vuex.mapState({ user: (state) => state.user.user }),
	},

	methods: {
		share () {
			// TODO
			console.log("SHARE ACTION HANDLER");
		}
	}
};

</script>



// WEBPACK FOOTER //
// src/components/widgets/RowActionWidgets/RowActionShare.vue